import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './social-proof.css';
import '../../../icon/icon.js';

/**
 * @typedef {Object} SocialProofItem
 * @property {string} icon - Icon name from the MDX icon sprite (optional)
 * @property {string} text - Social proof statement
 */

/**
 * Social Proof bar displaying 2–3 trust statements, each with an optional icon.
 * @property {SocialProofItem[]} items
 */
export default class SocialProof extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            items: [],
        };
    }

    template() {
        return html`
            <div
                class="flex flex-col items-start @md:items-center @md:flex-row @md:justify-center gap-fix-m @md:gap-fix-s @lg:gap-fix-m @xl:gap-fix-2xl border-b border-primary-subtle3 py-fix-m @md:py-fix-s @xl:py-fix-m text-green-medium"
            >
                ${this.items.map(
                    (item) => html`
                        <div
                            class="flex items-center gap-fix-s @lg:gap-fix-m @md:w-[228px] @lg:w-[280px] @xl:w-[318px]"
                        >
                            ${when(item.icon, html`<mb-icon size="32" name="${item.icon}" class="shrink-0"></mb-icon>`)}
                            <p class="fix-body2-medium @md:fix-body3 @lg:fix-body1-medium m-0 text-balance">
                                ${item.text}
                            </p>
                        </div>
                    `,
                )}
            </div>
        `;
    }
}

defineElement('mb-social-proof', SocialProof);
